import React  from 'react';

const RoundIcon = () => {
  return <svg xmlns="http://www.w3.org/2000/svg" className="round" width="34" height="34" viewBox="0 0 34 34">
  <g id="Group_523" data-name="Group 523" transform="translate(6079.81 -1064.797)">
    <rect id="Rectangle_162" data-name="Rectangle 162" width="34" height="34" transform="translate(-6079.81 1064.797)" fill="#fff"/>
    <path id="Path_5244" data-name="Path 5244" d="M-5991.782,1130.371h1.623l1.575,2.977h5.607l-2.895-8.358h2.165l5.88,8.223h3.4s2.768.631,2.757,1.384-2.513,1.5-2.757,1.5h-3.317l-5.928,8.173h-2.2l2.9-8.315h-5.607l-1.575,2.968h-1.623l1.3-4.294Z" transform="translate(-86.084 -58.833)" fill="#007bc2"/>
    <path id="Path_5245" data-name="Path 5245" d="M-5991.782,1130.371h1.623l1.575,2.977h5.607l-2.895-8.358h2.165l5.88,8.223h3.4s2.768.631,2.757,1.384-2.513,1.5-2.757,1.5h-3.317l-5.928,8.173h-2.2l2.9-8.315h-5.607l-1.575,2.968h-1.623l1.3-4.294Z" transform="translate(-12039.535 2222.428) rotate(180)" fill="#007bc2"/>
  </g>
</svg>


}

export default RoundIcon;
